import Configuration from '@/views/Configuration';
import Layout from '@/views/configuration/Layout';
import FormatBinding from '@/views/configuration/FormatBinding';
import Cover from '@/views/configuration/Cover';
import Content from '@/views/configuration/Content';
import Checkout from '@/views/configuration/Checkout';

const routePrefix = process.env.MIX_ROUTE_PREFIX;

const routes = [
  {
    path: `/${routePrefix}/:menuid?`,
    component: Configuration,
    props: true,
    name: 'configuration',
    children: [
      {
        path: 'layout',
        alias: '',
        component: Layout,
        name: 'layout',
        meta: {
          disabled: false,
          requiredAttributes: ['layout_id'],
        },
        props: {
          menu: {},
        },
        iconClass: 'bi-file-image',
        text: 'Stilvorlage',
      },
      {
        path: 'formatbinding',
        component: FormatBinding,
        name: 'formatbinding',
        meta: {
          disabled: true,
          requiredAttributes: ['data.binding', 'data.format', 'data.lamination'],
        },
        props: {
          menu: {},
        },
        iconClass: 'bi-journal-code',
        text: 'Format & Bindung',
      },
      {
        path: 'cover',
        component: Cover,
        name: 'cover',
        meta: {
          disabled: true,
          requiredAttributes: [],
        },
        props: {
          menu: {},
        },
        iconClass: 'bi-book',
        text: 'Umschlag',
      },
      {
        path: 'content',
        component: Content,
        name: 'content',
        meta: {
          disabled: true,
          requiredAttributes: [],
        },
        props: {
          menu: {},
        },
        iconClass: 'bi-list-columns',
        text: 'Inhalt',
      },
      {
        path: 'checkout',
        component: Checkout,
        name: 'checkout',
        meta: {
          disabled: true,
          requiredAttributes: [],
        },
        props: {
          menu: {},
        },
        iconClass: 'bi-cart3',
        text: 'Bestellung',
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: {},
  },
];

export default routes;
